import { IKvitteringData } from '../../ducks/kvittering/types'
import {
  IVirksomhetItem,
  IVirksomhetTilsynsobjekt,
} from '../../ducks/virksomhet-search/types'
import { ITilsynsobjekt } from '../../features/tilsynsobjekter/types'

export { sortByNavn, getIsTilsynsobjektItemEnabled }

const sortByNavn = (
  a: IVirksomhetTilsynsobjekt,
  b: IVirksomhetTilsynsobjekt
): 1 | -1 | 0 => {
  const x = a.navn.toLowerCase()
  const y = b.navn.toLowerCase()
  if (x < y) {
    return -1
  }
  if (x > y) {
    return 1
  }
  return 0
}

const getIsTilsynsobjektItemEnabled = (
  kvittering: IKvitteringData | undefined,
  virksomhetItem: IVirksomhetItem,
  unselectedMidlertidigTilsynsobjekt: ITilsynsobjekt | undefined
) => {
  const isVirksomhetTilsynsobjekterInKvittering = virksomhetItem.tilsynsobjekter
    .map((t) => t.idstring)
    .includes(kvittering?.tilsynsobjekter?.[0]?.tilsynsobjektId ?? '')

  const isEnabled =
    !kvittering?.virksomhetsNavn || isVirksomhetTilsynsobjekterInKvittering
  const isEnabledIfMidlertidig =
    (!!unselectedMidlertidigTilsynsobjekt &&
      kvittering?.tilsynsobjekter?.every((t) => t.midlertidig)) ??
    false

  return isEnabled || isEnabledIfMidlertidig
}
